// extracted by mini-css-extract-plugin
module.exports = {"container":"index_container-2R21a"};